import type { PointOfInterest } from "../../@types/mapviewxs";

export interface Input {
  pointsOfInterest: PointOfInterest[] | undefined;
}

interface State {
  drawCarousel: boolean;
}

export default class extends Marko.Component<Input, State> {
  onCreate() {
    this.state = {
      drawCarousel: true,
    };
  }

  onInput() {
    const carousel = this.getComponent("cool-carousel");
    if (carousel) {
      // Need to reset ebay carousel active item to the first item
      // NOTE: This is a workaround until we have a better way to reset the carousel position
      // The worarkound is to remove and re-render the carousel
      this.state.drawCarousel = false; // will force to remove carousel
      setTimeout(() => {
        this.state.drawCarousel = true; // bring back carousel
      });
    }
  }
}
